<div class="component-container h-full flex flex-col overflow-hidden">
  <div class="request-details flex flex-col flex-1 min-h-0 overflow-hidden">
    <div class="heading text-type-2 mb-[40px] flex-shrink-0">
      {{ data?.order_number }}
    </div>
    <mat-tab-group
      #tabGroup
      [selectedIndex]="selectedTabIndex"
      class="contents-tab-group flex-1 min-h-0 overflow-hidden"
    >
      <mat-tab label="Details">
        <app-change-orders-request-form
          class="tab-content"
        />
      </mat-tab>
      <mat-tab label="Workflow">
        <app-change-orders-request-workflow [data]="data" class="tab-content" />
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
